import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  ACTIVITY_STATUS,
  ALLOWED_FILES_REGEX,
  AUDIT_STATUS,
  STATUS_MAPPING,
} from "../../common/Constants";
import { validateFileWithContent, FILE_TYPE_GROUPS, FILE_SIZE_LIMITS, generateAcceptAttribute, VALIDATION_MESSAGES } from "../../../utils/fileValidation";
import { useGetVendorActivityDocuments } from "../../../backend/query";
import Icon from "../../common/Icon";
import { checkAuditorActivityStatus, download, extractTextContent, preventDefault } from "../../../utils/common";
import "./ActivityModal.css";
import * as api from "../../../backend/request";
import { toast } from "react-toastify";
import Select from "react-select";
import DatePicker from "react-datepicker";
import NavTabs from "../../shared/NavTabs";
import PageLoader from "../../shared/PageLoader";
import { Alert } from "react-bootstrap";
import { ACTIVITY_TYPE, EDITOR_CONFIG } from "../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faUpload } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";
import ConfirmModal from "../../common/ConfirmModal";
import { getUserDetails } from "../../../backend/auth";
import ReactQuill, { Quill } from "react-quill";

const TABS = {
  DETAILS: "details",
  FILES: "files",
};

const TABS_LIST = [
  { value: TABS.DETAILS, label: "Details" },
  { value: TABS.FILES, label: "Files" },
];

const FORM_STATUSES = [
  { value: ACTIVITY_STATUS.APPROVE, label: "Approve" },
  { value: ACTIVITY_STATUS.REJECT, label: "Reject" },
];

const AUDIT_STATUSES = [
  {
    value: AUDIT_STATUS.COMPLIANT,
    label: STATUS_MAPPING[AUDIT_STATUS.COMPLIANT],
  },
  {
    value: AUDIT_STATUS.NON_COMPLIANCE,
    label: STATUS_MAPPING[AUDIT_STATUS.NON_COMPLIANCE],
  },
  {
    value: AUDIT_STATUS.NOT_APPLICABLE,
    label: STATUS_MAPPING[AUDIT_STATUS.NOT_APPLICABLE],
  },
];

function StatusTmp({ status }: any) {
  return <span className={`status-${status}`}>{STATUS_MAPPING[status]}</span>;
}

function AuditorVendorActivityModal({ activity = {}, auditStatus: vendorAuditStatus, onClose, onSubmit }: any) {
  const [formStatus, setFormStatus] = useState(checkAuditorActivityStatus(activity, 'todo_vendor', vendorAuditStatus));
  const [activeTab, setActiveTab] = useState(TABS.DETAILS);
  const [submitting, setSubmitting] = useState(false);
  const [auditStatus, setAuditStatus] = useState<any>(
    AUDIT_STATUSES.find((x: any) => x.value === activity.audit_status) || null
  );
  const [status, setStatus] = useState<any>(
    FORM_STATUSES.find((x: any) => x.value === activity.status)
  );
  const [auditRemarks, setAuditRemarks] = useState(
    activity.audit_remarks
  );
  const [formsStatusRemarks, setFormsStatusRemarks] = useState(
    activity.forms_status_remarks
  );
  const [dueDate, setDueDate] = useState<any>(new Date(activity.due_date));
  const { documents, invalidate } = useGetVendorActivityDocuments(activity.id);
  const [file, setFile] = useState<any>(null);
  const [invalidFile, setInvalidFile] = useState(false);
  const [error, setError] = useState("");
  const [enableEditAlert, setEnableEditAlert] = useState<boolean>(false);
  const [reasonForChange, setReasonForChange] = useState<any>();
  const [editing, setEditing] = useState<boolean>(false);
  const editorConfig = EDITOR_CONFIG;
  const Block = Quill.import('blots/block');
  Block.tagName = 'DIV';
  Quill.register(Block, true);

  function onTabChange(event: any) {
    setActiveTab(event);
    // if (event === TABS.DETAILS) {
    //   setAuditStatus(undefined);
    //   setStatus(FORM_STATUSES.find((x: any) => x.value === activity.status));
    //   setAuditRemarks(undefined);
    //   setFormsStatusRemarks(activity.formsStatusRemarks);
    // }
  }

  function isInvalid() {
    const safeFormsStatusRemarks = extractTextContent(formsStatusRemarks || "").trim();
    const safeAuditRemarks = extractTextContent(auditRemarks || "").trim();

    return (
      !status ||
      (status.value === ACTIVITY_STATUS.APPROVE && !auditStatus) ||
      (activity.auditted !== ACTIVITY_TYPE.PHYSICAL_AUDIT &&
        status.value === ACTIVITY_STATUS.REJECT &&
        !auditStatus) ||
      (activity.auditted !== ACTIVITY_TYPE.PHYSICAL_AUDIT && status.value === ACTIVITY_STATUS.REJECT &&
        !safeFormsStatusRemarks) ||
      ([AUDIT_STATUS.NON_COMPLIANCE].includes((auditStatus || {}).value) &&
        !safeAuditRemarks) ||
      ([ACTIVITY_STATUS.APPROVE].includes(status.value) &&
        [AUDIT_STATUS.NOT_APPLICABLE].includes((auditStatus || {}).value) &&
        safeFormsStatusRemarks.length < 20)
    );
  }

  // function isInvalid() {
  //   return (
  //     !status ||
  //     (status.value === ACTIVITY_STATUS.APPROVE && !auditStatus) ||
  //     (activity.auditted !== ACTIVITY_TYPE.PHYSICAL_AUDIT && status.value === ACTIVITY_STATUS.REJECT && !auditStatus) ||
  //     (status.value === ACTIVITY_STATUS.REJECT &&
  //       !(formsStatusRemarks || "").trim()) ||
  //     ([AUDIT_STATUS.NON_COMPLIANCE].includes((auditStatus || {}).value) &&
  //       !(auditRemarks || "").trim()) ||
  //     ([ACTIVITY_STATUS.APPROVE].includes(status.value) &&
  //       [AUDIT_STATUS.NOT_APPLICABLE].includes((auditStatus || {}).value) &&
  //       formsStatusRemarks.trim().length < 20)
  //   );
  // }
  function submit() {
    if (
      [ACTIVITY_STATUS.APPROVE, AUDIT_STATUS.NOT_APPLICABLE].includes(
        status.value
      )
    ) {
      if (
        [AUDIT_STATUS.NOT_APPLICABLE].includes((auditStatus || {}).value) &&
        extractTextContent(formsStatusRemarks).length < 20
      ) {
        setError("Observations must be at least 20 characters long.");
        return;
      }
    }

    if(activity.published && (!reasonForChange || reasonForChange.length == 0)){
      toast.error("Reason for change is required");
      return;
    }

    setSubmitting(true);
    const payload: any = activity.published ? {
      audit_remarks: auditRemarks || "",
      audit_status: (auditStatus || {}).value || "",
      forms_status_remarks: formsStatusRemarks || "",
      status: status.value
    } :{
      todo_vendor: {
        audit_remarks: auditRemarks || "",
        audit_status: (auditStatus || {}).value || "",
        forms_status_remarks: formsStatusRemarks || "",
        status: status.value,
        audited_date: new Date().toISOString()
      }
    };
    if([ACTIVITY_STATUS.REJECT].includes(status.value)){
      if(activity.published) {
        payload.due_date = new Date(dueDate).toISOString();
      } else {
        payload.todo_vendor.due_date = new Date(dueDate).toISOString();
      }
    }
    if(activity.published) {
      payload.todo_vendor_id = activity.id;
      payload.reason_for_change = reasonForChange;
    }

    if(activity.published){
      api
        .post("/api/v1/todo_vendors/edit_post_publish", payload)
        .then((response: any) => {
          if (response instanceof AxiosError){
            const data = (response.response || {}).data;
            const error = (data || {}).error || "Activity updated failed. Please try again";
            toast.error(error);
          } else {
            toast.success("Activity updated successfully.");
            onSubmit();
            onClose();
          }
        })
        .finally(() => setSubmitting(false));
    } else {
      const action = status.value == 'Approved' ? 'approve' : 'reject'
      api
        .put(`/api/v1/todo_vendors/${activity.id}/${action}`, payload)
        .then((response: any) => {
          if (response instanceof AxiosError){
              const data = (response.response || {}).data;
              const error = (data || {}).error || "Activity updated failed. Please try again";
              toast.error(error);
          } else {
            toast.success("Activity updated successfully.");
            onSubmit();
            onClose();
          }
        })
        .finally(() => setSubmitting(false));
    }
  }

  async function onFileChange(event: any) {
    const selectedFile = event.target.files[0];

    if (!selectedFile) {
      setFile(null);
      setInvalidFile(false);
      return;
    }

    // Show loading state
    setInvalidFile(false);

    // Validate file with deep content inspection (checks for XSS, macros, scripts)
    const validation = await validateFileWithContent(
      selectedFile,
      FILE_TYPE_GROUPS.ALL_DOCUMENTS,
      FILE_SIZE_LIMITS.LARGE
    );

    if (!validation.isValid) {
      setInvalidFile(true);
      setFile(null);
      toast.error(validation.error);
      // Clear file input
      event.target.value = '';
      return;
    }

    setFile(selectedFile);
    setInvalidFile(false);
  }

  function uploadFile() {
    setSubmitting(true);
    const formData = new FormData();
    formData.append("file", file, file.name);
    api
      .post(`/api/v1/todo_vendor_details/upload?todo_vendor_id=${activity.id}`, formData)
      .then(() => {
        setFile(null);
        setInvalidFile(false);
        invalidate();
        toast.success("File uploaded successfully.");
      })
      .finally(() => setSubmitting(false));
  }

  useEffect(() => {
    if (status) {
      
      // Clear fields when changing to Reject
      if (status.value === ACTIVITY_STATUS.REJECT) {
        // alert("1a");
        // alert(status.value);
        //setAuditRemarks(""); // Clear audit remarks
        //setFormsStatusRemarks(""); // Clear observations
      }

      // Clear fields when changing to Approve
      if (status.value === ACTIVITY_STATUS.APPROVE) {
        // alert("1b");
        // alert(status.value);
        //setFormsStatusRemarks("");
        //setAuditRemarks(""); // Clear observations (optional, depending on requirements)
      }
    }
  }, [status, auditStatus]);

  useEffect(() => {

    // Reset fields when compliance status changes to Not Applicable
    if (auditStatus && auditStatus.value === AUDIT_STATUS.NOT_APPLICABLE) {
        // alert("1c");
        // alert(auditStatus.value);
      //setAuditRemarks("");
      //setFormsStatusRemarks("");
      // Clear audit remarks
    }
  }, [auditStatus, status]);

  useEffect(() => {
   
    if (status) {
        //alert("1c");
        //alert(status.value);
      // setDueDate(new Date(activity.due_date));
      // if (status.value === ACTIVITY_STATUS.REJECT) {
        //alert("1d");
        //setAuditRemarks(null);
        // setAuditStatus(null);
      // }
    }
  }, [status]);

  function onStatusChange(event: any) {
    setStatus(event);
    if(event && event.value) {
      setDueDate(new Date(activity.due_date));
      setAuditStatus(null);
    }
  }

  useEffect(() => {
    if (!dueDate) {
      setDueDate(new Date(activity.due_date));
    }
  }, [dueDate]);

  function handleEdit(e: any) {
    e.preventDefault();
    if(activity.auditted === ACTIVITY_TYPE.NO_AUDIT){
      setFormStatus({
        editable: false,
        type: 'info',
        message: `This activity doesn't required any action.`,
        alertMessage: ""
      });
    } else {
      setFormStatus({editable: true});
    }
    setEditing(true);
  }

  return (
    <>
      <Modal
        show={true}
        backdrop="static"
        animation={false}
        size="lg"
        dialogClassName="activity-modal"
      >
        <Modal.Header closeButton={true} onHide={onClose}>
          <Modal.Title className="bg">Activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(formStatus || {}).message && <>
            {(!activity.published || editing) && <Alert variant={formStatus.type}>
              <div className="d-flex justify-content-between">
                <span>{formStatus.message}</span>
                {(activity.auditted === ACTIVITY_TYPE.AUDIT) && (activity.status === ACTIVITY_STATUS.AUDITED) && <span style={{cursor: "pointer"}} onClick={() => setEnableEditAlert(true)}>
                  <FontAwesomeIcon icon={faPencil} />
                  <span className="px-1">Edit</span>
                </span>}
              </div>
            </Alert>}
            {activity.published && !editing && <Alert variant={formStatus.type}>
              {formStatus.message}
            </Alert>}
          </>}
          <NavTabs list={TABS_LIST} onTabChange={onTabChange} />
          {activeTab === TABS.DETAILS && (
            <>
              <div className="d-flex justify-content-center px-4 py-2">
                <div className="col-12">
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Act</div>
                    <div className="col">{(activity.act || {}).name}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Rule</div>
                    <div className="col">{(activity.rule || {}).name}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">
                      Forms/Registers & Returns
                    </div>
                    <div className="col">{(activity.activity || {}).name}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Activity Type</div>
                    <div className="col">{(activity.activity || {}).activity_type}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Month(Year)</div>
                    <div className="col">
                      {activity.month} ({activity.year})
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Evidence Status</div>
                    <div className="col">
                      {activity.status && (
                        <StatusTmp status={activity.status} />
                      )}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Audit Type</div>
                    <div className="col">
                      {activity.auditted || ACTIVITY_TYPE.AUDIT}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Auditee Remarks</div>
                    <div className="col">
                      {activity.auditee_remarks}
                    </div>
                  </div>
                  {/* {activity.auditStatus ?  */}
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Compliance Status </div>
                    <div className="col">
                      {activity.audit_status }
                    </div>
                  </div> 
                  {/* {activity.formsStatusRemarks ?  */}
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Observations</div>
                    <div className="col" dangerouslySetInnerHTML={{ __html: activity.forms_status_remarks || "" }}>

                    </div>
                  </div>
                  {/* {activity.auditRemarks ?  */}
                  <div className="row mb-2">
                    <div className="col-4 filter-label">Reccomendations</div>
                    <div className="col" dangerouslySetInnerHTML={{ __html: activity.audit_remarks || "" }}>

                    </div>
                  </div> 
                </div>
              </div>

              {(formStatus || {}).editable && (
                  <div className="px-4">
                    <form className="vendor_activity_form">
                      <div className="row mt-3">
                        <div className="col-5">
                          <div className="col-12 mb-4">
                            <label className="filter-label">
                              Evidence Status<span className="required">*</span>
                            </label>
                            <Select
                              placeholder="Evidence Status"
                              options={FORM_STATUSES}
                              onChange={onStatusChange}
                              value={status}
                            />
                          </div>
                        </div>
  
                        {(status || {}).value === ACTIVITY_STATUS.APPROVE && (
                          <div className="col-5">
                            <div className="col-12 mb-4">
                              <label className="filter-label">
                                Compliance Status
                                <span className="required">*</span>
                              </label>
                              <Select
                                placeholder="Compliance Status"
                                options={
                                  (status || {}).value === ACTIVITY_STATUS.APPROVE
                                    ? AUDIT_STATUSES.filter((option) =>
                                        [
                                          AUDIT_STATUS.COMPLIANT,
                                          AUDIT_STATUS.NOT_APPLICABLE,
                                        ].includes(option.value)
                                      )
                                    : AUDIT_STATUSES
                                }
                                onChange={setAuditStatus}
                                value={auditStatus}
                              />
                            </div>
                          </div>
                        )}


                          {(status || {}).value === ACTIVITY_STATUS.REJECT &&
                            activity.auditted !==
                              ACTIVITY_TYPE.PHYSICAL_AUDIT && (
                                <div className="col-5">
                            <div className="col-12 mb-4">
                              {/* <div className="row-12">
                                <div className="row-5 mb-4"> */}
                                  <label className="filter-label">
                                    Compliance Status
                                    <span className="required">*</span>
                                  </label>
                                  <Select
                                    placeholder="Compliance Status"
                                    options={
                                      (status || {}).value ===
                                      ACTIVITY_STATUS.REJECT
                                        ? AUDIT_STATUSES.filter((option) =>
                                            [
                                              AUDIT_STATUS.NON_COMPLIANCE,
                                              AUDIT_STATUS.NOT_APPLICABLE,
                                            ].includes(option.value)
                                          )
                                        : AUDIT_STATUSES
                                    }
                                    onChange={setAuditStatus}
                                    value={auditStatus}
                                  />
                                </div>
                              </div>
                            )}
                      </div>

                      <div className="row">
                        <div className="col-10 mb-4">
                          <label className="filter-label">
                            Observations
                            {auditStatus &&
                              [
                                AUDIT_STATUS.NON_COMPLIANCE,
                                AUDIT_STATUS.NOT_APPLICABLE,
                                ACTIVITY_STATUS.REJECT,
                              ].includes(auditStatus.value) && (
                                <span className="required">*</span>
                              )}
                          </label>
                          

                          {/* <textarea
                            className="form-control"
                            value={formsStatusRemarks}
                            onChange={(e) =>
                              setFormsStatusRemarks(e.target.value)
                            }
                            disabled={false}
                          /> */}
                          <ReactQuill theme="snow" className={`form-control ${auditStatus &&
                              (status || {}).value === ACTIVITY_STATUS.APPROVE &&
                              auditStatus.value === AUDIT_STATUS.NOT_APPLICABLE && extractTextContent(formsStatusRemarks).length < 20 ? 'is-invalid' : ''}`}
                            modules={editorConfig.modules} formats={editorConfig.formats} value={formsStatusRemarks} onChange={setFormsStatusRemarks} style={{height: '160px'}}
                            id={`quillContainer_formsStatusRemarks`} bounds={`#quillContainer_formsStatusRemarks`} />

                            {auditStatus &&
                              (status || {}).value === ACTIVITY_STATUS.APPROVE &&
                              auditStatus.value === AUDIT_STATUS.NOT_APPLICABLE && (
                                <div
                                  className={`mt-1 ${
                                    (formsStatusRemarks && extractTextContent(formsStatusRemarks).length < 20)
                                      ? "text-danger"
                                      : "text-primary"
                                  }`}
                                >
                                  {(formsStatusRemarks && extractTextContent(formsStatusRemarks).length < 20)
                                    ? `At least 20 characters required`
                                    : ``}
                                </div>
                            )}
                        </div>
                      </div>

                      <div className="row">
                        {(status || {}).value === ACTIVITY_STATUS.APPROVE && (
                          <div className="col-10">
                            <div className="col-12 mb-4">
                              <label className="filter-label">
                                Recommendations
                                {/* {[AUDIT_STATUS.NON_COMPLIANCE].includes((auditStatus || {}).value) && <span className="required">*</span>} */}
                              </label>
                              {/* <textarea
                                className="form-control"
                                value={auditRemarks}
                                required={auditRemarks}
                                onChange={(e) => setAuditRemarks(e.target.value)}
                              /> */}
                              <ReactQuill theme="snow" className={`form-control`}
                                modules={editorConfig.modules} formats={editorConfig.formats} value={auditRemarks} onChange={setAuditRemarks} style={{height: '160px'}}
                                id={`quillContainer_auditRemarks`} bounds={`#quillContainer_auditRemarks`} />
                            </div>
                          </div>
                        )}


                        {(status || {}).value === ACTIVITY_STATUS.REJECT &&
                          activity.auditted !==
                            ACTIVITY_TYPE.PHYSICAL_AUDIT && (
                          <div className="col-10">
                            <div className="col-12 mb-4">
                              <label className="filter-label">
                                Recommendations
                                {[AUDIT_STATUS.NON_COMPLIANCE].includes(
                                  (auditStatus || {}).value
                                ) && <span className="required">*</span>}
                              </label>
                              {/* <textarea
                                className="form-control"
                                value={auditRemarks}
                                required={auditRemarks}
                                onChange={(e) =>
                                  setAuditRemarks(e.target.value)
                                }
                              /> */}
                              <ReactQuill theme="snow" className={`form-control`}
                                modules={editorConfig.modules} formats={editorConfig.formats} value={auditRemarks} onChange={setAuditRemarks} style={{height: '160px'}}
                                id={`quillContainer_auditRemarks_reject`} bounds={`#quillContainer_auditRemarks_reject`} />
                            </div>
                            <div className="col-8 mb-4">
                              <label className="filter-label">
                                Vendor Due Date
                                {[AUDIT_STATUS.NON_COMPLIANCE].includes(
                                  (auditStatus || {}).value
                                ) && <span className="required">*</span>}
                              </label>
                              <DatePicker
                                className="form-control"
                                selected={dueDate}
                                dateFormat="dd-MM-yyyy"
                                onChange={setDueDate}
                                placeholderText="dd-mm-yyyy"
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        )}

                        {activity.published && <div className="col-10 mb-4">
                          <label className="filter-label">
                            Reason for Change
                            <span className="required">*</span>
                          </label>
                          

                          <textarea
                            className="form-control"
                            value={reasonForChange}
                            onChange={(e) =>
                              setReasonForChange(e.target.value)
                            }
                            disabled={false}
                          />
                        </div>}
                      </div>
                    </form>
                  </div>
                )}
            </>
          )}
          {activeTab === TABS.FILES && (
            <div className="d-flex justify-content-center">
              <div className="col-10">
                {(formStatus || {}).editable &&
                  activity.auditted === ACTIVITY_TYPE.PHYSICAL_AUDIT && (
                    <>
                      <div className="row my-4">
                        <div className="col w-100">
                          <input
                            id="fileUpload"
                            type="file"
                            className="form-control"
                            onChange={onFileChange}
                            accept={generateAcceptAttribute(FILE_TYPE_GROUPS.ALL_DOCUMENTS)}
                          />
                          {invalidFile && (
                            <div className="text-danger">
                              {" "}
                              <small>{VALIDATION_MESSAGES.INVALID_FILE_ALL_DOCS}</small>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-2">
                          <Button
                            variant="outline-primary"
                            disabled={!file || invalidFile}
                            onClick={uploadFile}
                          >
                            <div className="d-flex align-items-center justify-content-center w-100">
                              <FontAwesomeIcon icon={faUpload} />
                              <span className="ms-2">Upload</span>
                            </div>
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                <table className="table modalTable fixed_header">
                  <thead>
                    <tr>
                      <th style={{ width: "75%" }}>File Name</th>
                      <th style={{ width: "25%" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody style={{ height: "300px" }}>
                    {documents.map((file: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td width="75%" style={{ overflowWrap: "break-word" }}>{file.file_name}</td>
                          <td width="25%">
                            <div className="d-flex flex-row align-items-center">
                              <Icon
                                name={"download"}
                                action={() =>
                                  download(file.file_name, file.file_path)
                                }
                                text="Download"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {documents.length === 0 && (
                      <tr>
                        <td
                          colSpan={2}
                          rowSpan={4}
                          width="100%"
                          style={{ height: "200px", border: 0 }}
                        >
                          <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                            No files available
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
          {(formStatus || {}).editable && activeTab === TABS.DETAILS ? (
            <div className="d-flex flex-row justify-content-between w-100">
              <Button variant="secondary" onClick={onClose}>
                Back
              </Button>
              <Button variant="primary" onClick={submit} disabled={isInvalid()}>
                Submit
              </Button>
            </div>
          ) : (
            <Button variant="primary" onClick={onClose}>
              Close
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {enableEditAlert && <ConfirmModal
        message={formStatus.alertMessage}
        onClose={(e: any) => {
          preventDefault(e);
          setEnableEditAlert(false);
        }}
        onSubmit={handleEdit}
      />}
      
      {submitting && <PageLoader />}
    </>
  );
}

export default AuditorVendorActivityModal;
